import React, { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; 
import './DashboardBultos.css';
import './DashboardInventario.css';
import './Trade-Form.css'; 
import { useQuery } from '../QueryContext';
import { useAuth } from '../AuthContext'; 
import { CircleCheckBig } from 'lucide-react';
import imageCompression from 'browser-image-compression';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const SUB_ACTIVIDADES_MAP = {
  "Impulsos": ["Producto de Marca", "Sencillos (PDV)", "Patrocinios", "Eventos - Carrera","Otros"],
  "Revestimientos": ["Cabezal", "Muebles Cabezales", "De categoria","Otros"],
  "Exhibidores": ["Checkout", "EXH", "Botadero", "Exhibidores de Piso", "Ristras", "Otros"],
  "POP": ["Danglers", "Rompetraficos", "Afiche", "Material POP", "Cenefa", "Predicadors", "Colgantes", "Papel Bobina","Otros"],
  "Vaya Publicitaria": [],
  "Otros": []
};

const ACTIVIDADES_OPCIONES = ["Impulsos", "Revestimientos", "POP", "Exhibidores", "Vaya Publicitaria"];
const APERTURA_OPCIONES = ["NO", "SI"];
const CARGO_TO_REGION_SOLICITANTE = {
  "COORD. NAC. TRADEMARKETING C.OCC. Y CENTRO": "CENTRO - CENTRO OCCIDENTE",
  "COORD. NAC. TRADEMARKETING OCCIDENTE Y ANDES": "OCCIDENTE - ANDES",
  "COORD. NAC. TRADEMARKETING ORIENTE NORTE": "ORIENTE NORTE",
  "COORD. NAC. TRADEMARKETING ORIENTE SUR": "ORIENTE SUR",
  "COORD. TRADEMARKETING CAPITAL": "CAPITAL"
};

  const addBusinessDays = (startDate, days) => {
  const result = new Date(startDate);
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);

    const day = result.getDay();

    if (day !== 0 && day !== 6) {
      added++;
    }
  }

  return result;
};

const TradeForm = () => {
  const { profile } = useAuth(); 
  const { getTradeCatalogos, postTradeFormulario } = useQuery();

  const allowedRoles = [
    "Coordinador de Inteligencia de Negocio",
    "Coord. Nac. ADC",
    "Coord. Nac. Impulsos y POP",
    "Coord. Nac. Mercaderistas",
    "Coord. Nac. Trademarketing C.Occ. y Centro",
    "Coord. Nac. Trademarketing Occidente y Andes",
    "Coord. Nac. Trademarketing Oriente Norte",
    "Coord. Nac. Trademarketing Oriente Sur",
    "Coord. Trademarketing Capital",
    "Directora Comercial",
    "Gerente de Administración de Ventas",
    "Gte. Ejecución en PDV",
    "Gerente Nacional de Ventas"
  ];

  const [clientes, setClientes] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [previewImgs, setPreviewImgs] = useState([]);
  const [cargandoCatalogos, setCargandoCatalogos] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null); 
  const [enviando, setEnviando] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Estados locales temporales para las horas
  const [horaInicio, setHoraInicio] = useState('');
  const [horaFin, setHoraFin] = useState('');

  // Buscadores de texto temporales
  const [searchInputs, setSearchInputs] = useState({
    id_cliente: '', cliente_principal: '', cliente_nombre: '', marca: '', actividad: '', sub_actividad: '', apertura: ''
  });

  const [formData, setFormData] = useState({
    T_ID_CLIENTE: '', T_CLI_PRIN: '', T_CLI_NOMBRE: '', T_MARCA: '', T_REGION: '',
    T_DIRECCION: '', T_ACTIVIDAD: '', T_SUB_ACTIVIDAD: '', T_MOTIVO: '', T_REQUERIMIENTO: '',
    T_ASESOR_RELACIONADO: '', T_RANGO: 'NO APLICA', T_APERTURA: 'NO', T_FECHA_ACT: '', T_CANT_IMP: ''
  });

  const handleImagenesChange = async (e) => {
  const files = Array.from(e.target.files);

  const options = {
    maxSizeMB: 0.8,
    maxWidthOrHeight: 1280,
    useWebWorker: true
  };

  try {
    const comprimidas = await Promise.all(
      files.map(async (file) => {
        if (file.size > 5 * 1024 * 1024) {
          alert(`La imagen ${file.name} supera los 5MB`);
          return null;
        }

        const compressedFile = await imageCompression(file, options);

        return compressedFile;
      })
    );

    const validas = comprimidas.filter(Boolean);

    setImagenes(validas);

    // previews
    const previews = validas.map(file => ({
      file,
      url: URL.createObjectURL(file)
    }));

    setPreviewImgs(previews);

  } catch (err) {
    console.error("Error comprimiendo imágenes", err);
  }
};

  const [popSeleccionados, setPopSeleccionados] = useState({});
  const formRef = useRef(null);

  const ambasCapital =
  formData.T_REG_SOL === 'CAPITAL' &&
  formData.T_REGION === 'CAPITAL (MIRANDA VARGAS)';

const diasAnticipacion = ambasCapital ? 2 : 3;

const fechaMinimaActividad =
  (formData.T_ACTIVIDAD === 'IMPULSOS' ||
   formData.T_ACTIVIDAD === 'POP')
    ? addBusinessDays(new Date(), diasAnticipacion)
        .toISOString()
        .split('T')[0]
    : new Date().toISOString().split('T')[0];

  useEffect(() => {
  if (formData.T_ACTIVIDAD !== 'REVESTIMIENTOS') {
    setImagenes([]);
    setPreviewImgs([]);
  }
}, [formData.T_ACTIVIDAD]);

  useEffect(() => {
    const cargarData = async () => {
      try {
        const res = await getTradeCatalogos();
        if (res && res.success) {
          setClientes(res.clientes || []);
          setMarcas(res.marcas || []);
        }
      } catch (err) {
        console.error("Error al cargar catálogos de Trade", err);
      } finally {
        setCargandoCatalogos(false);
      }
    };
    cargarData();
  }, [getTradeCatalogos]);

  useEffect(() => {
    const cargo = (profile?.cargo || '').toUpperCase().trim();
    const regionSolicitante = CARGO_TO_REGION_SOLICITANTE[cargo] || 'CAPITAL';
    setFormData(prev => ({ ...prev, T_REG_SOL: regionSolicitante }));
  }, [profile?.cargo]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtrados = {
    id_cliente: clientes.filter(c => c.id_cliente.toLowerCase().includes(searchInputs.id_cliente.toLowerCase())),
    cliente_principal: [...new Set(clientes.map(c => c.cliente_principal))].filter(cp => cp.toLowerCase().includes(searchInputs.cliente_principal.toLowerCase())),
    cliente_nombre: clientes.filter(c => c.cliente_nombre.toLowerCase().includes(searchInputs.cliente_nombre.toLowerCase())),
    marca: marcas.filter(m => m.toLowerCase().includes(searchInputs.marca.toLowerCase())),
    
    actividad: ACTIVIDADES_OPCIONES.filter(act => 
      act.toUpperCase().includes(searchInputs.actividad.toUpperCase())
    ),

    apertura: APERTURA_OPCIONES.filter(opc => 
      opc.toUpperCase().includes(searchInputs.apertura.toUpperCase())
    ),
    
    sub_actividad: (() => {
      const claveOriginal = Object.keys(SUB_ACTIVIDADES_MAP).find(key => key.toUpperCase() === formData.T_ACTIVIDAD);
      const subCategorias = SUB_ACTIVIDADES_MAP[claveOriginal] || [];
      return subCategorias.filter(sub => sub.toUpperCase().includes(searchInputs.sub_actividad.toUpperCase()));
    })()
  };

  const handleNormalChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value.toUpperCase() }));
  };

  const handleSelectActividad = (actividadSeleccionada) => {
    setPopSeleccionados({}); 
    const actUpper = actividadSeleccionada.toUpperCase();
    setSearchInputs(prev => ({ ...prev, actividad: actUpper, sub_actividad: '' })); 
    
    const subActividadInicial = actUpper === "VAYA PUBLICITARIA" ? "NO APLICA" : "";
    
    if (actUpper !== 'IMPULSOS' && actUpper !== 'POP') {
      setHoraInicio('');
      setHoraFin('');
    }

    setFormData(prev => ({ 
      ...prev, 
      T_ACTIVIDAD: actUpper, 
      T_SUB_ACTIVIDAD: subActividadInicial,
      T_RANGO: (actUpper === 'IMPULSOS' || actUpper === 'POP') ? '' : 'NO APLICA'
    }));
    setActiveDropdown(null);
  };

  const handlePopCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setPopSeleccionados(prev => {
      const nuevoEstado = { ...prev, [name]: checked };
      const stringResultado = Object.keys(nuevoEstado)
        .filter(key => nuevoEstado[key])
        .join(', ')
        .toUpperCase();
      setFormData(formDataPrev => ({ ...formDataPrev, T_SUB_ACTIVIDAD: stringResultado }));
      return nuevoEstado;
    });
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    const upperValue = value.toUpperCase();
    setSearchInputs(prev => ({ ...prev, [name]: upperValue }));

    if (name === 'id_cliente' || name === 'cliente_principal' || name === 'cliente_nombre') {
      setFormData(prev => ({
        ...prev,
        T_ID_CLIENTE: name === 'id_cliente' ? upperValue : '',
        T_CLI_PRIN: name === 'cliente_principal' ? upperValue : '',
        T_CLI_NOMBRE: name === 'cliente_nombre' ? upperValue : '',
        T_REGION: '', T_DIRECCION: '', T_ASESOR_RELACIONADO: '', T_CANT_IMP: ''
      }));
    } else if (name === 'marca') {
      setFormData(prev => ({ ...prev, T_MARCA: upperValue }));
    } else if (name === 'actividad') {
      const actUpper = upperValue;
      setFormData(prev => ({ 
        ...prev, 
        T_ACTIVIDAD: actUpper,
        T_RANGO: (actUpper === 'IMPULSOS' || actUpper === 'POP') ? '' : 'NO APLICA'
      }));
    } else if (name === 'apertura') {
      setFormData(prev => ({ ...prev, T_APERTURA: upperValue }));
    }
  };

  const handleInputFocus = (dropdownKey, inputKey) => {
    setActiveDropdown(dropdownKey);
    setSearchInputs(prev => ({ ...prev, [inputKey]: '' }));
  };

  const handleSelectCliente = (clienteObj) => {
    setFormData(prev => ({
      ...prev,
      T_ID_CLIENTE: clienteObj.id_cliente.toUpperCase(),
      T_CLI_PRIN: clienteObj.cliente_principal.toUpperCase(),
      T_CLI_NOMBRE: clienteObj.cliente_nombre.toUpperCase(),
      T_REGION: clienteObj.region.toUpperCase(),
      T_ASESOR_RELACIONADO: (clienteObj.vendedor || '').toUpperCase()
    }));

    setSearchInputs({
      id_cliente: clienteObj.id_cliente.toUpperCase(),
      cliente_principal: clienteObj.cliente_principal.toUpperCase(),
      cliente_nombre: clienteObj.cliente_nombre.toUpperCase(),
      marca: searchInputs.marca,
      actividad: searchInputs.actividad,
      sub_actividad: '',
      apertura: searchInputs.apertura
    });
    setActiveDropdown(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (enviando) return;

    const ahora = new Date();
    const FECHA_REGISTRO = `${ahora.getFullYear()}-${String(ahora.getMonth() + 1).padStart(2, '0')}-${String(ahora.getDate()).padStart(2, '0')} ${String(ahora.getHours()).padStart(2, '0')}:${String(ahora.getMinutes()).padStart(2, '0')}:${String(ahora.getSeconds()).padStart(2, '0')}`;
    const T_SOLICITANTE = (profile?.nombre || '').toUpperCase();

    // FIX (frontend): asegurar que T_REG_SOL NO llegue vacío al submit.
    // Puede ocurrir un desfasaje entre el useEffect de autocompletado y el click en Enviar.
    const cargoSolicitante = (profile?.cargo || '').toUpperCase().trim();
    const fallbackRegSol = CARGO_TO_REGION_SOLICITANTE[cargoSolicitante] || 'CAPITAL';
    const T_REG_SOL = (formData?.T_REG_SOL || '').toString().toUpperCase().trim() || fallbackRegSol;

    let rangoFinal = formData.T_RANGO;
    if (formData.T_ACTIVIDAD === 'IMPULSOS' || formData.T_ACTIVIDAD === 'POP') {
      if (!horaInicio || !horaFin) {
        alert("Error: El rango de horas es obligatorio para Impulsos y POP.");
        return;
      }
      rangoFinal = `${horaInicio} A ${horaFin}`;
    }

    if (
      (formData.T_ACTIVIDAD === 'IMPULSOS' ||
      formData.T_ACTIVIDAD === 'POP') &&
      formData.T_FECHA_ACT
    ) {
      const fechaMinima = addBusinessDays(
        new Date(),
        diasAnticipacion
      );

      const fechaActividad = new Date(
        formData.T_FECHA_ACT + 'T00:00:00'
      );

      fechaMinima.setHours(0,0,0,0);

      if (fechaActividad < fechaMinima) {
        alert(
          `La fecha de actividad debe tener al menos ${diasAnticipacion} días hábiles de anticipación.`
        );
        return;
      }
    }

      const payloadFinal = {
        FECHA_REGISTRO,
        T_SOLICITANTE,
        T_ESTATUS: 'REGISTRO',
        ...formData,
        T_REG_SOL, // FIX: garantizado por fallback arriba
        T_RANGO: rangoFinal
      };

      // DEBUG: validar qué campos se están enviando realmente
      const requiredKeys = [
        'FECHA_REGISTRO',
        'T_SOLICITANTE',
        'T_ID_CLIENTE',
        'T_CLI_PRIN',
        'T_CLI_NOMBRE',
        'T_MARCA',
        'T_REGION',
        'T_REG_SOL',
        'T_DIRECCION',
        'T_ACTIVIDAD',
        'T_SUB_ACTIVIDAD',
        'T_RANGO',
        'T_APERTURA',
        'T_MOTIVO',
        'T_REQUERIMIENTO',
        'T_ASESOR_RELACIONADO',
        'T_ESTATUS'
      ];

      const missingForDebug = requiredKeys.filter((k) => {
        const v = payloadFinal[k];
        return v === null || v === undefined || v.toString().trim() === '';
      });

      if (missingForDebug.length > 0) {
        alert(
          `Error: faltan campos obligatorios para el backend: ${missingForDebug.join(', ')}\n\nRevisar actividad/sub-actividad/apertura.`
        );
        console.error('DEBUG campos faltantes payloadFinal:', { payloadFinal, missingForDebug });
        return;
      }

      const formDataToSend = new FormData();
      Object.entries(payloadFinal).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });


      imagenes.forEach((file) => {
        formDataToSend.append("imagenes", file);
      });
      // Solo exigir cantidad para IMPULSOS
      if (payloadFinal.T_ACTIVIDAD !== 'IMPULSOS') {
        delete payloadFinal.T_CANT_IMP;
      }

    // Campos opcionales según actividad
      const camposOpcionales = [];

      if (
        payloadFinal.T_ACTIVIDAD !== 'IMPULSOS' &&
        payloadFinal.T_ACTIVIDAD !== 'POP'
      ) {
        camposOpcionales.push('T_FECHA_ACT');
      }

      if (payloadFinal.T_ACTIVIDAD !== 'IMPULSOS') {
        camposOpcionales.push('T_CANT_IMP');
      }

      // Validación final
      const camposVacios = Object.keys(payloadFinal).filter(key => {
        if (camposOpcionales.includes(key)) return false;

        return (
          payloadFinal[key] === null ||
          payloadFinal[key] === undefined ||
          payloadFinal[key].toString().trim() === ''
        );
      });

      if (camposVacios.length > 0) {
        alert(
          `Error: Todos los campos son estrictamente obligatorios. Por favor rellene: ${camposVacios.join(', ')}`
        );
        return;
      }

    try {
      setEnviando(true);
      const resultado = await postTradeFormulario(formDataToSend);
      
      if (resultado && resultado.success) {
        setShowSuccessModal(true);
        
        setFormData({
          T_ID_CLIENTE: '', T_CLI_PRIN: '', T_CLI_NOMBRE: '', T_MARCA: '', T_REGION: '',
          T_DIRECCION: '', T_ACTIVIDAD: '', T_SUB_ACTIVIDAD: '', T_MOTIVO: '', T_REQUERIMIENTO: '',
          T_ASESOR_RELACIONADO: '', T_RANGO: 'NO APLICA', T_APERTURA: 'NO', T_FECHA_ACT: '', T_CANT_IMP: ''
        });
        
        setSearchInputs({
          id_cliente: '', cliente_principal: '', cliente_nombre: '', marca: '', actividad: '', sub_actividad: '', apertura: ''
        });

        setHoraInicio('');
        setHoraFin('');
        setPopSeleccionados({});
      } else {
        alert(`Error desde el servidor: ${resultado?.detail || "No se pudo completar el registro."}`);
      }
    } catch (error) {
      console.error(error);
      alert("Ocurrió un fallo de red crítico al conectar con el Backend.");
    } finally {
      setEnviando(false);
    }
  };

  if (profile && !allowedRoles.includes(profile.cargo)) {
    return <Navigate to="/home" replace />;
  }

  return (
    <motion.div 
      className="dashboard-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={isMobile ? { duration: 0.3 } : { duration: 0.6 }}
    >
      <header className="header-flex">
        <div className="title-section">
          <h1 className="dashboard-title">Formulario de Solicitudes</h1>
          <div className="title-underline"></div>
        </div>
      </header>

      <div className="trade-form-wrapper" ref={formRef}>
        <div className="form-internal-header">
          <span className="form-subtitle">Módulo de Trade-Marketing</span>
          <h2 className="form-main-title">Nueva Solicitud</h2>
          <p className="form-description"> Todos los campos sin excepción son obligatorios.</p>
        </div>

        <form onSubmit={handleSubmit} className="trade-form" id="trade-form-element">

          {/* ======================== */}
          {/* Informacion General      */}
          {/* ======================== */}
          <div className="trade-form-section">
            <div className="trade-form-section-title">Informacion General</div>

            <div className="form-group">
              <label>Solicitante *</label>
              <input
                type="text"
                value={(profile?.nombre || 'Cargando usuario...').toUpperCase()}
                disabled
              />
            </div>

                        {/* INPUT: REGIÓN SOLICITANTE (READONLY) */}
            <div className="form-group">
              <label>Región Solicitante*</label>
              <input
                type="text"
                name="T_REG_SOL"
                value={formData.T_REG_SOL}
                readOnly
                placeholder="Autocompletado según cargo"
                required
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  cursor: 'not-allowed',
                  opacity: 0.7,
                  textTransform: 'uppercase'
                }}
              />
            </div>


            {/* BUSCADOR CUSTOM: NOMBRE COMPLETO CLIENTE */}
            <div className="form-group">
              <label>Nombre Completo Cliente *</label>
              <div className="custom-dropdown-container">
                <input
                  type="text"
                  name="cliente_nombre"
                  value={searchInputs.cliente_nombre}
                  onChange={handleSearchChange}
                  onFocus={() => handleInputFocus('nombre', 'cliente_nombre')}
                  placeholder="BUSCAR POR NOMBRE..."
                  required
                  autoComplete="off"
                  disabled={enviando}
                  style={{ textTransform: 'uppercase' }}
                />
                {activeDropdown === 'nombre' && (
                  <ul className="dropdown-menu-list">
                    {filtrados.cliente_nombre.length > 0 ? (
                      filtrados.cliente_nombre.map((c, i) => (
                        <li key={`nom-${i}`} className="dropdown-item" onClick={() => handleSelectCliente(c)}>
                          {c.cliente_nombre} ({c.id_cliente})
                        </li>
                      ))
                    ) : <li className="dropdown-no-results">No se encontraron registros</li>}
                  </ul>
                )}
              </div>
            </div>

            {/* BUSCADOR CUSTOM: ID CLIENTE */}
            <div className="form-group">
              <label>ID Cliente *</label>
              <input
                type="text"
                value={formData.T_ID_CLIENTE}
                readOnly
                required
                placeholder="AUTOCOMPLETADO"
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  cursor: 'not-allowed',
                  opacity: 0.7,
                  textTransform: 'uppercase'
                }}
              />
            </div>

            {/* BUSCADOR CUSTOM: CLIENTE PRINCIPAL */}
            <div className="form-group">
              <label>Cliente Principal *</label>
              <input
                type="text"
                value={formData.T_CLI_PRIN}
                readOnly
                required
                placeholder="AUTOCOMPLETADO"
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  cursor: 'not-allowed',
                  opacity: 0.7,
                  textTransform: 'uppercase'
                }}
              />
            </div>

            {/* INPUT: REGION (READONLY) */}
            <div className="form-group">
              <label>Región - Asesor*</label>
              <input
                type="text"
                name="T_REGION"
                value={formData.T_REGION}
                readOnly
                placeholder="Autocompletado obligatorio"
                required
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  cursor: 'not-allowed',
                  opacity: 0.7,
                  textTransform: 'uppercase'
                }}
              />
            </div>

            {/* INPUT: ASESOR RELACIONADO (READONLY) */}
            <div className="form-group">
              <label>Asesor Relacionado *</label>
              <input
                type="text"
                name="T_ASESOR_RELACIONADO"
                value={formData.T_ASESOR_RELACIONADO}
                readOnly
                placeholder="Autocompletado obligatorio"
                required
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.15)',
                  cursor: 'not-allowed',
                  opacity: 0.7,
                  textTransform: 'uppercase'
                }}
              />
            </div>

            {/* TEXTAREA: DIRECCIÓN */}
            <div className="form-group">
              <label>Dirección - Sede *</label>
              <input
                name="T_DIRECCION"
                value={formData.T_DIRECCION}
                onChange={handleNormalChange}
                rows="2"
                placeholder="COLOQUE LA DIRECCIÓN DE LA SEDE..."
                required
                disabled={enviando}
                style={{ textTransform: 'uppercase' }}
              />
            </div>
          </div>

          <div className="trade-form-divider" />

          {/* ======================== */}
          {/* Solicitud                */}
          {/* ======================== */}
          <div className="trade-form-section-title">Solicitud</div>

          {/* BUSCADOR CUSTOM DE MARCA */}
          <div className="form-group">
            <label>Marca *</label>
            <div className="custom-dropdown-container">
              <input
                type="text"
                name="marca"
                value={searchInputs.marca || formData.T_MARCA}
                onChange={handleSearchChange}
                onFocus={() => handleInputFocus('marca', 'marca')}
                placeholder="BUSCAR MARCA..."
                required
                autoComplete="off"
                disabled={enviando}
                style={{ textTransform: 'uppercase' }}
              />
              {activeDropdown === 'marca' && (
                <ul className="dropdown-menu-list">
                  {filtrados.marca.length > 0 ? (
                    filtrados.marca.map((m, i) => (
                      <li
                        key={`marca-${i}`}
                        className="dropdown-item"
                        onClick={() => {
                          setFormData(prev => ({ ...prev, T_MARCA: m.toUpperCase() }));
                          setSearchInputs(prev => ({ ...prev, marca: m.toUpperCase() }));
                          setActiveDropdown(null);
                        }}
                      >
                        {m}
                      </li>
                    ))
                  ) : <li className="dropdown-no-results">No se encontraron registros</li>}
                </ul>
              )}
            </div>
          </div>

          {/* --- BUSCADOR CUSTOM NUEVO: ¿ES APERTURA? --- */}
          <div className="form-group">
            <label>¿Es Apertura? *</label>
            <div className="custom-dropdown-container">
              <input
                type="text"
                name="apertura"
                value={activeDropdown === 'apertura' ? searchInputs.apertura : formData.T_APERTURA}
                onChange={handleSearchChange}
                onFocus={() => handleInputFocus('apertura', 'apertura')}
                placeholder="SELECCIONAR SI / NO..."
                required
                autoComplete="off"
                disabled={enviando}
                style={{ textTransform: 'uppercase' }}
              />
              {activeDropdown === 'apertura' && (
                <ul className="dropdown-menu-list">
                  {filtrados.apertura.length > 0 ? (
                    filtrados.apertura.map((opc, i) => (
                      <li
                        key={`opc-${i}`}
                        className="dropdown-item"
                        onClick={() => {
                          setFormData(prev => ({ ...prev, T_APERTURA: opc.toUpperCase() }));
                          setSearchInputs(prev => ({ ...prev, apertura: opc.toUpperCase() }));
                          setActiveDropdown(null);
                        }}
                      >
                        {opc}
                      </li>
                    ))
                  ) : <li className="dropdown-no-results">No se encontraron opciones</li>}
                </ul>
              )}
            </div>
          </div>

          {/* CAMPO CUSTOM: ACTIVIDAD */}
          <div className="form-group">
            <label>Actividad *</label>
            <div className="custom-dropdown-container">
              <input
                type="text"
                name="actividad"
                value={activeDropdown === 'actividad' ? searchInputs.actividad : formData.T_ACTIVIDAD}
                onChange={handleSearchChange}
                onFocus={() => handleInputFocus('actividad', 'actividad')}
                placeholder="Buscar o elegir actividad..."
                required
                autoComplete="off"
                disabled={enviando}
                style={{ textTransform: 'uppercase' }}
              />
              {activeDropdown === 'actividad' && (
                <ul className="dropdown-menu-list">
                  {filtrados.actividad.length > 0 ? (
                    filtrados.actividad.map((act, i) => (
                      <li key={`act-${i}`} className="dropdown-item" onClick={() => handleSelectActividad(act)}>
                        {act}
                      </li>
                    ))
                  ) : <li className="dropdown-no-results">No se encontraron actividades</li>}
                </ul>
              )}
            </div>
          </div>

          {/* CAMPO DINÁMICO: SUB-ACTIVIDADES */}
          {formData.T_ACTIVIDAD && formData.T_ACTIVIDAD !== 'VAYA PUBLICITARIA' && (
            formData.T_ACTIVIDAD === 'POP' ? (
              <div className="form-group full-width" style={{ marginTop: '5px' }}>
                <label style={{ marginBottom: '10px', display: 'block', fontWeight: 'bold' }}>
                  Seleccione los elementos POP requeridos * (Múltiple):
                </label>
                <div style={{ 
                  display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr', gap: '12px',
                  backgroundColor: 'var(--bg-navbar)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
                  padding: '15px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                }}>
                  {SUB_ACTIVIDADES_MAP["POP"].map((opcion, index) => (
                    <label key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '12px', color: 'var(--text-third)' }}>
                      <input 
                        type="checkbox" name={opcion} checked={!!popSeleccionados[opcion]} onChange={handlePopCheckboxChange}
                        disabled={enviando}
                        style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: 'var(--line-inven)' }}
                      />
                      {opcion.toUpperCase()}
                    </label>
                  ))}
                </div>
              </div>
            ) : (
              <div className="form-group">
                <label>Sub-Actividad de {formData.T_ACTIVIDAD} *</label>
                <div className="custom-dropdown-container">
                  <input 
                    type="text" name="sub_actividad" value={activeDropdown === 'sub' ? searchInputs.sub_actividad : formData.T_SUB_ACTIVIDAD}
                    onChange={handleSearchChange} onFocus={() => handleInputFocus('sub', 'sub_actividad')}
                    placeholder="Buscar o elegir sub-categoría..." required autoComplete="off" disabled={enviando}
                    style={{ textTransform: 'uppercase' }}
                  />
                  {activeDropdown === 'sub' && (
                    <ul className="dropdown-menu-list">
                      {filtrados.sub_actividad.length > 0 ? (
                        filtrados.sub_actividad.map((sub, i) => (
                          <li key={`sub-${i}`} className="dropdown-item" onClick={() => {
                            setFormData(prev => ({ ...prev, T_SUB_ACTIVIDAD: sub.toUpperCase() }));
                            setSearchInputs(prev => ({ ...prev, sub_actividad: sub.toUpperCase() }));
                            setActiveDropdown(null);
                          }}>
                            {sub}
                          </li>
                        ))
                      ) : <li className="dropdown-no-results">No se encontraron sub-categorías</li>}
                    </ul>
                  )}
                </div>
              </div>
            )
          )}

          {/* CAMPO CONDICIONAL: CANT. IMP */}
          {formData.T_ACTIVIDAD === 'IMPULSOS' && (
            <div className="form-group">
              <label>CANT: IMPULSOS *</label>
              <input
                type="number"
                min="1"
                step="1"
                name="T_CANT_IMP"
                value={formData.T_CANT_IMP}
                onChange={(e) =>
                  setFormData(prev => ({
                    ...prev,
                    T_CANT_IMP: e.target.value
                  }))
                }
                placeholder="INDIQUE LA CANTIDAD"
                required
                disabled={enviando}
              />
            </div>
          )}


          {/* CAMPO CONDICIONAL: FECHA ACTIVIDAD */}

          {(formData.T_ACTIVIDAD === 'IMPULSOS' ||
          formData.T_ACTIVIDAD === 'POP') && (
          <div className="form-group">
            <label>Fecha de Actividad *</label>

            <input
              type="date"
              name="T_FECHA_ACT"
              value={formData.T_FECHA_ACT}
              min={fechaMinimaActividad}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  T_FECHA_ACT: e.target.value
                }))
              }
              required
              disabled={enviando}
            />

            {(formData.T_ACTIVIDAD === 'IMPULSOS' ||
              formData.T_ACTIVIDAD === 'POP') && (
              <small
                style={{
                  color: '#990000',
                  marginTop: '6px',
                  display: 'block'
                }}
              >
                La actividad debe solicitarse con al menos{" "}
                <strong>{diasAnticipacion} días hábiles</strong> de anticipación.
              </small>
            )}
          </div>
        )}

          {/* CAMPO CONDICIONAL: RANGO DE HORAS */}
          {(formData.T_ACTIVIDAD === 'IMPULSOS' || formData.T_ACTIVIDAD === 'POP') && (
            <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label>Rango de Horario de Actividad *</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input 
                  type="time" 
                  value={horaInicio} 
                  onChange={(e) => setHoraInicio(e.target.value)} 
                  required 
                  disabled={enviando}
                  style={{ width: '45%', color: '#fff', backgroundColor: 'var(--bg-navbar)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '5px', padding: '8px' }}
                />
                <span style={{ color: 'var(--text-third)', fontWeight: 'bold' }}>A</span>
                <input 
                  type="time" 
                  value={horaFin} 
                  onChange={(e) => setHoraFin(e.target.value)} 
                  required 
                  disabled={enviando}
                  style={{ width: '45%', color: '#fff', backgroundColor: 'var(--bg-navbar)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '5px', padding: '8px' }}
                />
              </div>
            </div>
          )}

          {formData.T_ACTIVIDAD === 'REVESTIMIENTOS' && (
            <div className="form-group full-width">
              <label>Imágenes (evidencia) *</label>

              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImagenesChange}
                disabled={enviando}
                required
              />
            </div>
          )}

          {formData.T_ACTIVIDAD === 'REVESTIMIENTOS' && previewImgs.length > 0 && (
            <div style={{
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap',
              marginTop: '10px'
            }}>
              {previewImgs.map((img, idx) => (
                <img
                  key={idx}
                  src={img.url}
                  alt={`preview-${idx}`}
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}
                />
              ))}
            </div>
          )}

          <div className="form-group">
            <label>Motivo *</label>
            <input 
              type="text" name="T_MOTIVO" value={formData.T_MOTIVO} onChange={handleNormalChange} 
              placeholder="EJ. IMPULSO DE VENTAS" required disabled={enviando} style={{ textTransform: 'uppercase' }} 
            />
          </div>

          <div className="form-group full-width">
            <label>Detalle del Requerimiento *</label>
            <textarea 
              name="T_REQUERIMIENTO" value={formData.T_REQUERIMIENTO} onChange={handleNormalChange} 
              rows="4" placeholder="ESCRIBA AQUÍ LOS DETALLES..." required disabled={enviando} 
              style={{ textTransform: 'uppercase' }}
            />
          </div>
        </form>
      </div>

      <div className="submit-btn-container">
        <button type="submit" form="trade-form-element" className="trade-submit-btn" disabled={cargandoCatalogos || enviando}>
          {enviando ? "Guardando en Base de Datos..." : "Enviar Solicitud"}
        </button>
      </div>

      {/* POP-UP MODAL DE ÉXITO INTEGRADO */}
      <AnimatePresence>
        {showSuccessModal && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
            alignItems: 'center', zIndex: 9999, backdropFilter: 'blur(5px)'
          }}>
            <motion.div 
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              transition={{ type: 'spring', damping: 25, stiffness: 300 }}
              style={{
                background: 'linear-gradient(90deg, #0068b3, rgb(20, 20, 20))', padding: '30px',
                borderRadius: '12px', textAlign: 'center', maxWidth: '400px', width: '90%',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
              }}
            >
              <CircleCheckBig 
                size={55} 
                style={{ color: '#00ba52', marginBottom: '15px' }} 
              />
              <h3 style={{ color: 'white', margin: '0 0 10px 0', fontSize: '22px', fontFamily: 'sans-serif' }}>¡OPERACIÓN EXITOSA!</h3>
              <p style={{ color: '#ffffff', fontSize: '14px', marginBottom: '25px', lineHeight: '1.5' }}>
                LA SOLICITUD HA SIDO ENVIADA.
              </p>
              <button 
                onClick={() => setShowSuccessModal(false)}
                style={{
                  backgroundColor: '#00ba52', color: '#1e1e2f', border: 'none',
                  padding: '10px 25px', borderRadius: '6px', fontWeight: 'bold',
                  cursor: 'pointer', fontSize: '14px', transition: '0.2s'
                }}
                onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                ENTENDIDO
              </button>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

    </motion.div>
  );
};

export default TradeForm;